import { CicloI } from "interfaces/Ciclo";
import { ReactNode, useState } from "react";
import { Table } from "react-bootstrap";
import { CicloRow } from "./CicloRow";

interface Props {
  elementos: CicloI[];
  renderActions?: (elemento: CicloI) => ReactNode;
}

export const CicloTable = ({ elementos = [], renderActions }: Props) => {
  const [selectedNotificacionId, setSelectedNotificacionId] = useState<
    null | number | string
  >(null);

  const [showDetailModal, setShowDetailModal] = useState(false);

  const handleShowDetailModal = (id: number | string) => {
    setSelectedNotificacionId(id);
    setShowDetailModal(true);
  };

  const handleCloseModal = () => {
    setShowDetailModal(false);
  };

  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Nombre</th>
            <th>Descripción</th>
            <th>Año Inicial</th>
            <th>Año Final</th>
            {renderActions && (
              <th className="text-center" style={{ maxWidth: "50px" }}>
                Acciones
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <CicloRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={renderActions}
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 6 : 5}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay Ciclos para visualizar.</b> Para poder visualizar
                  ciclos debes <br /> seleccionar el botón agregar «Nuevo
                  Ciclo».
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
